var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupsMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_601_35",
    "data-name": "Component 601 \\u2013 35",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10853",
    "data-name": "Rectangle 10853",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-140 -129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M130.863,36.858c1.761,0,3.188-1.734,3.188-3.872s-.469-3.872-3.188-3.872-3.188,1.734-3.188,3.872S129.1,36.858,130.863,36.858Z",
    transform: "translate(21.451 103.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M80.666,202.155c-.059-3.725-.546-4.787-4.269-5.459a2.615,2.615,0,0,1-3.491,0c-3.682.665-4.2,1.71-4.267,5.338-.006.3-.008.312-.009.277,0,.064,0,.184,0,.391,0,0,.886,1.787,6.021,1.787s6.021-1.787,6.021-1.787c0-.133,0-.226,0-.289A2.351,2.351,0,0,1,80.666,202.155Z",
    transform: "translate(77.662 -55.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M262.875,51.308a2.908,2.908,0,0,0,2.589-3.145c0-1.737-.381-3.145-2.589-3.145a3.692,3.692,0,0,0-.966.115,6.346,6.346,0,0,1,.58,2.994,5.31,5.31,0,0,1-.8,2.834A2.218,2.218,0,0,0,262.875,51.308Z",
    transform: "translate(-106.137 88.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M288.817,185.559c-.048-3.026-.443-3.888-3.467-4.434a1.813,1.813,0,0,1-1.418.542c-.041,0-.081,0-.12,0a3.978,3.978,0,0,1,1.626,1.259c.73,1,.9,2.346.933,4.322,2.034-.4,2.451-1.241,2.451-1.241,0-.109,0-.184,0-.236A1.815,1.815,0,0,1,288.817,185.559Z",
    transform: "translate(-127.194 -40.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M50.544,51.309a2.219,2.219,0,0,0,1.181-.347,5.31,5.31,0,0,1-.8-2.834,6.348,6.348,0,0,1,.58-2.994,3.691,3.691,0,0,0-.966-.115c-2.209,0-2.589,1.408-2.589,3.145A2.908,2.908,0,0,0,50.544,51.309Z",
    transform: "translate(97.346 88.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M5.01,181.663c-.039,0-.079,0-.12,0a1.813,1.813,0,0,1-1.418-.542c-3.024.546-3.419,1.408-3.467,4.434a1.836,1.836,0,0,1-.006.209c0,.051,0,.126,0,.236,0,0,.417.839,2.451,1.242.035-1.976.2-3.32.933-4.322A3.978,3.978,0,0,1,5.01,181.663Z",
    transform: "translate(143 -40.83)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsMenu);
export default __webpack_public_path__ + "static/media/groups-menu.8e1d0517dbaecae103a2593aba0b07d1.svg";
export { ForwardRef as ReactComponent };